import type { SourceTypes } from "./server-list-types";
import type { GatewayWithSourceViewStateTypes } from "./gateways-list-types";

export interface MachinesListDataTypes extends SourceTypes {
  id: string;
  gateway_id: string;
  gateway_name?: string;
  visibility?: "public" | "private";
  approved_duration?: string;
  isActive?: boolean;
  isRequested?: boolean;
  timeDuration?: string;
  timePeriod?: "hours" | "minutes";
  requested_duration?: string;
  technician_user_id?: string;
  technician_namespace?: string;
  operator_user_id?: string;
  gateway_device?: Device | null;
  message?: string;
  vendor_id?: string;
  websocket_auth_key?: string | null;
  websocket_auth_key_expiration?: string | null;
  followers_user_ids?: string[];
  status?: MachinesListSupportSessionsStatusTypes;
  remaining_duration?: string |  null;
}

export interface Device {
  created_at: string;
  updated_at: string;
  id: string;
  auth_key_id: string;
  auth_key_expiration?: string | null;
  namespace: string;
  type: string;
  description: string;
  ip: string;
  node_id: string;
  inactive: boolean;
  metadata?: Record<string, unknown> | null;
}

export interface MachinesListSupportSessionsCancelRequestModalTextTypes {
  title: string;
  message: string;
  confirmButton: string;
  cancelButton: string;
}

export enum MachinesListSupportSessionsStatusTypes {
  IDLE = "IDLE",
  REQUESTED = "REQUESTED",
  CANCELLED = "CANCELLED",
  DENIED = "DENIED",
  ACCEPTED = "ACCEPTED",
  INITIAL = "INITIAL",
  IN_PROGRESS = "IN_PROGRESS",
  OPEN = "OPEN",
}

export enum MachinesListSupportSessionsZitadelRoleTypes {
  REQUEST_VPN = "request-vpn",
  ACCEPT_VPN = "accept-vpn",
  MANAGE_VPN = "manage-vpn"
}

export type transformedGatewaysWithMachinesListEntryTypes = Omit<GatewayWithSourceViewStateTypes, "sources"| "vendor_id" | "can_be_claimed"> & {
  sources: Record<string, MachinesListDataTypes>;
};